import React from "react";
import { Link } from "react-router-dom";

import { textbookPath, chooseTextbookPath } from "../../../teacherStore";
import Button from "../../../atoms/ActiveLearning/Button";

import styles from "./SelectTextbookPage.module.scss";

export default () => {
  return (
    <div className={styles.wrapper} id="accordion">
      <div className={styles.container}>
        <p className={styles.title}>授業する教材を選んでください</p>
        <div className={styles.buttonWrapper}>
          <Link
            className={styles.link}
            to={`${textbookPath}${chooseTextbookPath}`}
          >
            <Button width={"100%"}>BASE/CORE基礎編</Button>
          </Link>
          <Link
            className={styles.link}
            to={`${textbookPath}${chooseTextbookPath}?isActiveLearning=true`}
          >
            <Button width={"100%"}>CORE実践編</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
